module.exports = __webpack_public_path__ + "img/aif.3d445227.png";